import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _Math$random, _Math$random$substrin;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 平台体验度量新增埋点
// https://www.tapd.cn/20584651/prong/stories/view/1120584651001443986
import { getPageIdInfo, loadJS, isiOS, isZZ } from "../../../utils/common";
import Pagelife from "../../../lego-pagelife";
import { zzsdk } from "../../../utils/initLoadSdk";
import Logger from "../../../utils/log";
import { initBase } from "../performance/base";
import lego from "../../../lego";
import { getQuery } from "../../../utils/common";
var TIME_OUT = 10 * 1e3; // 超时时间
var randomString = Math === null || Math === void 0 || (_Math$random = Math.random()) === null || _Math$random === void 0 || (_Math$random = _Math$random.toString(36)) === null || _Math$random === void 0 || (_Math$random$substrin = _Math$random.substring) === null || _Math$random$substrin === void 0 ? void 0 : _Math$random$substrin.call(_Math$random, 2, 15);
// 只支持浏览器环境
if (typeof window !== 'undefined' && window !== null) {
  // 数据放到window，因为不同埋点都会取到，且里边值填充时间不固定
  if (!window['MEASUREMENT_PERF_DATA' + randomString]) {
    window['MEASUREMENT_PERF_DATA' + randomString] = {
      h5pageLoadingTime: 0,
      // H5静态资源加载时间
      h5pageLoadedTime: 0,
      // H5静态资源加载完时间
      pageHiddenCount: 0,
      // 第几次离开
      pageShowCount: 0,
      // 第几次显示
      pageOpenTime: null,
      // 页面跳转时间（客户端）
      pageLoadingTime: null,
      // 页面跳转时间（客户端）
      pageShowTime: null,
      // 页面开始渲染时间
      pageRenderingTime: null,
      // 首屏渲染完成时间,会在发送首屏埋点的时候将值合并到这个对象下
      pageDataLoadedTime: null,
      // 页面完全渲染时间
      pageScrollTime: null,
      // 首次滑动时间
      pageHiddenTime: null // 首次滑动时间
    };
  }
}
export var setWinMeasurementPerfData = function setWinMeasurementPerfData(key, value) {
  if (window['MEASUREMENT_PERF_DATA' + randomString]) {
    window['MEASUREMENT_PERF_DATA' + randomString][key] = value;
  }
};
export var getWinMeasurementPerfData = function getWinMeasurementPerfData(key) {
  if (window['MEASUREMENT_PERF_DATA' + randomString]) {
    return window['MEASUREMENT_PERF_DATA' + randomString][key];
  }
  return null;
};
var sendData = function sendData(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    var _getPageIdInfo;
    var pagetype = null;
    switch (type) {
      case 'pageOpenNative':
        pagetype = 'pageOpen';
        break;
      case 'pageshow':
        pagetype = 'pageShowPerf';
        break;
      case 'pageload':
        pagetype = 'pageDataLoaded';
        break;
      case 'scrollStart':
        pagetype = 'pageScroll';
        break;
      case 'pagehide':
        pagetype = 'pageHidden';
        break;
      default:
        return;
    }
    lego.send(_objectSpread(_objectSpread({}, params), initBase({
      backup: _objectSpread(_objectSpread({
        log_type: 'm'
      }, window['MEASUREMENT_PERF_DATA' + randomString]), {}, {
        infoid: getQuery('infoid') || getQuery('infoId'),
        brandid: getQuery('brandid') || getQuery('brandId'),
        modelid: getQuery('modelid') || getQuery('modelid')
      })
    }, {
      pagetype: pagetype,
      actiontype: (_getPageIdInfo = getPageIdInfo()) === null || _getPageIdInfo === void 0 ? void 0 : _getPageIdInfo.pageId
    })));
  } catch (error) {
    Logger.error('体验度量埋点发送失败' + error);
  }
};
var addListenerPageOpenNative = function addListenerPageOpenNative() {
  var getPageLifecycleTime = function getPageLifecycleTime() {
    try {
      window.__ZZAPP__.hasSupportFeature({
        method: 'getPageLifecycleTime'
      }, function (res) {
        if (res && res.code === '1') {
          window.__ZZAPP__.run('getPageLifecycleTime', {}, function (resp) {
            if (resp.code == '0' && (resp.openTime || resp.loadingTime)) {
              setWinMeasurementPerfData('pageOpenTime', resp.openTime);
              setWinMeasurementPerfData('pageLoadingTime', resp.loadingTime);
              // 仅记录时间不发埋点
            }
          });
        }
      });
    } catch (error) {
      Logger.error('体验度量获取客户端时间失败' + error);
    }
  };
  if (window.__ZZAPP__) {
    getPageLifecycleTime();
  } else {
    loadJS(zzsdk, function () {
      getPageLifecycleTime();
    });
  }
};
var addListenerPageshow = function addListenerPageshow() {
  // 忽略预渲染，每次调用性能埋点时都触发一次
  setWinMeasurementPerfData('pageShowTime', Date.now());
  setWinMeasurementPerfData('pageShowCount', getWinMeasurementPerfData('pageShowCount') + 1);
  // 只记录时间不发送埋点-因为此时有可能拿不到pageId
  // sendData('pageshow') 
};
var addListenerLoad = function addListenerLoad() {
  window.addEventListener('load', function () {
    // 如果用了骨架屏,此时还未获取到loadEventEnd,所以加了个递归查询
    try {
      var dp = function dp(time) {
        setTimeout(function () {
          if (performance.timing.loadEventEnd != time) {
            // 如果需要发送埋点的话，需要再判断下 || !getPageIdInfo()?.pageId
            dp(performance.timing.loadEventEnd);
          } else {
            var pageDataLoadedTime = performance.timing.loadEventEnd || Date.now();
            setWinMeasurementPerfData('pageDataLoadedTime', pageDataLoadedTime);
            // 仅记录时间不发埋点
            // sendData('pageload', { timestamp: pageDataLoadedTime });
          }
        }, 300);
      };
      dp(performance.timing.loadEventEnd);
    } catch (error) {
      Logger.error('体验度量监听load事件失败' + error);
    }
  });
};
var addListenerScrollStart = function addListenerScrollStart() {
  function listenTouchS(e) {
    var _e$touches;
    // 避免滑动退出行为被记录
    if ((_e$touches = e.touches) !== null && _e$touches !== void 0 && (_e$touches = _e$touches[0]) !== null && _e$touches !== void 0 && _e$touches.screenX && e.touches[0].screenX > 40 && window.innerHeight - e.touches[0].clientY > 40) {
      saveData();
    }
  }
  function saveData() {
    setWinMeasurementPerfData('pageScrollTime', Date.now());
    // 仅记录时间不发埋点
    // sendData('scrollStart')
    window.removeEventListener('touchstart', listenTouchS, true);
    window.removeEventListener('scroll', saveData);
  }
  window.addEventListener('touchstart', listenTouchS, true);
  window.addEventListener('scroll', saveData);
};
var addListenerUnload = function addListenerUnload() {
  var sendHide = function sendHide() {
    setWinMeasurementPerfData('pageHiddenCount', getWinMeasurementPerfData('pageHiddenCount') + 1);
    setWinMeasurementPerfData('pageHiddenTime', Date.now());
    sendData('pagehide');
  };
  var customOnHide = function customOnHide() {
    try {
      var startX, endX;
      document.addEventListener('touchstart', function (e) {
        startX = e.touches[0].screenX;
      });
      document.addEventListener('touchend', function (e) {
        endX = e.changedTouches[0].screenX;
        if (startX < 10 && endX >= -340 && endX < 0) {
          sendHide();
        }
      });
      // 还有一部分向后跳页的隐藏是可以监听到的
      Pagelife.add('onHide', function () {
        sendHide();
      });
    } catch (error) {
      Logger.error('体验度量自定义返回失败' + error);
    }
  };
  var addEventNativeIosHide = function addEventNativeIosHide() {
    var getIOSHide = function getIOSHide() {
      try {
        window.__ZZAPP__.hasSupportFeature({
          method: 'registerLifecycleEventWillHide'
        }, function (res) {
          if (res && res.code === '1') {
            window.__ZZAPP__.run('registerLifecycleEventWillHide', {}, function (resp) {
              if (resp && resp.code == '0') {
                sendHide();
              }
            });
          } else {
            customOnHide();
          }
        });
      } catch (error) {
        customOnHide();
      }
    };
    if (window.__ZZAPP__) {
      getIOSHide();
    } else {
      loadJS(zzsdk, function () {
        getIOSHide();
      });
    }
  };
  // 端外及非IOS端
  if (!isiOS || !isZZ()) {
    Pagelife.add('onHide', function () {
      sendHide();
    });
  } else {
    //IOS端对onHide新增加了一个方法
    addEventNativeIosHide();
  }
};
var wrapResolve = function wrapResolve(type, resolve) {
  var _performance$timing, _performance$timing2, _performance$timing3, _performance$timing4;
  var timer = setTimeout(function () {
    resolve(_defineProperty(_defineProperty(_defineProperty({}, type, '0'), "type", type), "msg", '执行超时'));
  }, TIME_OUT);
  switch (type) {
    case 'fetchStart':
      clearTimeout(timer);
      setWinMeasurementPerfData('h5pageLoadingTime', (_performance$timing = performance.timing) === null || _performance$timing === void 0 ? void 0 : _performance$timing.fetchStart);
      resolve({
        data: {},
        value: (_performance$timing2 = performance.timing) === null || _performance$timing2 === void 0 ? void 0 : _performance$timing2.fetchStart,
        type: type,
        msg: ''
      });
      break;
    case 'domLoading':
      clearTimeout(timer);
      setWinMeasurementPerfData('h5pageLoadedTime', (_performance$timing3 = performance.timing) === null || _performance$timing3 === void 0 ? void 0 : _performance$timing3.domLoading);
      resolve({
        data: {},
        value: (_performance$timing4 = performance.timing) === null || _performance$timing4 === void 0 ? void 0 : _performance$timing4.domLoading,
        type: type,
        msg: ''
      });
      break;
    case 'pageOpenNative':
      clearTimeout(timer);
      addListenerPageOpenNative();
      resolve({
        data: {},
        value: 0,
        type: type,
        msg: ''
      });
      break;
    case 'pageshow':
      clearTimeout(timer);
      addListenerPageshow();
      resolve({
        data: {},
        value: 0,
        type: type,
        msg: ''
      });
      break;
    case 'pageload':
      clearTimeout(timer);
      addListenerLoad();
      resolve({
        data: {},
        value: 0,
        type: type,
        msg: ''
      });
      break;
    case 'scrollStart':
      clearTimeout(timer);
      addListenerScrollStart();
      resolve({
        data: {},
        value: 0,
        type: type,
        msg: ''
      });
      break;
    case 'pagehide':
      clearTimeout(timer);
      addListenerUnload();
      resolve({
        data: {},
        value: 0,
        type: type,
        msg: ''
      });
      break;
    default:
      return;
  }
};
export var sendFMP = function sendFMP(fmpTimestamp) {
  if (typeof fmpTimestamp !== 'number') return null;
  setWinMeasurementPerfData('pageRenderingTime', fmpTimestamp);
  // 暂时不需要发送埋点只需要记录时间
  // try {
  //   let dpCount = 0
  //   const dp = () => {
  //     if (getPageIdInfo()?.pageId && getPageIdInfo().pageId !== 'PERFORMANCE') {
  //       lego.send({
  //         timestamp: fmpTimestamp,
  //         ...initBase({
  //           backup: {
  //             log_type: 'm',
  //             ...(Object.assign((window['MEASUREMENT_PERF_DATA' + randomString] || {}), {
  //               pageRenderingTime: fmpTimestamp
  //             }))
  //           }
  //         }, {
  //           pagetype: 'pageRendering',
  //           actiontype: getPageIdInfo().pageId,
  //         })
  //       })
  //     } else {
  //       setTimeout(() => {
  //         dpCount = dpCount + 1
  //         if (dpCount < 40) dp()
  //       }, 100)
  //     }
  //   }
  //   dp()
  // } catch (error) {
  //   Logger.error('体验度量首屏渲染埋点发送失败')
  // }
};
export var calcFetchStart = function calcFetchStart() {
  return new Promise(function (resolve) {
    return wrapResolve('fetchStart', resolve);
  });
};
export var calcDomLoading = function calcDomLoading() {
  return new Promise(function (resolve) {
    return wrapResolve('domLoading', resolve);
  });
};
export var calcPageOpenNative = function calcPageOpenNative() {
  return new Promise(function (resolve) {
    return wrapResolve('pageOpenNative', resolve);
  });
};
export var calcPageshow = function calcPageshow() {
  return new Promise(function (resolve) {
    return wrapResolve('pageshow', resolve);
  });
};
export var calcPageload = function calcPageload() {
  return new Promise(function (resolve) {
    return wrapResolve('pageload', resolve);
  });
};
export var calcScrollStart = function calcScrollStart() {
  return new Promise(function (resolve) {
    return wrapResolve('scrollStart', resolve);
  });
};
export var calcPagehide = function calcPagehide() {
  return new Promise(function (resolve) {
    return wrapResolve('pagehide', resolve);
  });
};
export var initPreRenderMeasure = function initPreRenderMeasure() {
  var currentTime = Date.now();
  setWinMeasurementPerfData('h5pageLoadingTime', currentTime);
  setWinMeasurementPerfData('h5pageLoadedTime', currentTime);
  setWinMeasurementPerfData('pageShowTime', currentTime);
  setWinMeasurementPerfData('pageDataLoadedTime', currentTime);
  calcPageOpenNative();
  calcScrollStart();
  calcPagehide();
};